import React from 'react';
import { Button, Spin } from 'antd';
import { useMobxStores } from '@/stores';
import { observer } from 'mobx-react-lite';
import { LoadingOutlined } from './Icons';

const LoadMoreBtn = ({ facility_id }) => {
  const { reservationStore } = useMobxStores();

  const isLoading =
    reservationStore.initReviewsLoading || reservationStore.reviewsLoading;

  const reviewsLoaded = reservationStore.reviewsList?.length ?? 0;
  const totalReviews = reservationStore.reviewsTotal ?? 0;
  const canLoadMore = reviewsLoaded < totalReviews;

  return (
    <div className="flex justify-center items-center">
      {isLoading ? (
        <Spin indicator={<LoadingOutlined className="text-5xl" spin />} />
      ) : (
        <Button
          type="default"
          onClick={() =>
            reservationStore.onLoadMoreReviewsSortStar(facility_id)
          }
          disabled={!canLoadMore}
          className={`bg-white text-secondary hover:opacity-70 rounded-full uppercase text-sm px-8 font-bold border-none shadow-none items-center ${
            canLoadMore
              ? 'hover:bg-white hover:text-secondary'
              : 'w-full hover:bg-deal hover:text-white'
          }`}
          size="large"
        >
          {canLoadMore ? 'Show more reviews' : 'No more reviews to load'}
        </Button>
      )}
    </div>
  );
};

export default observer(LoadMoreBtn);
